import { defaults } from 'lodash';
import { useEffect } from 'react';

import { useAsyncAction } from './use-async-action';

export function useAsync(action, dependencies, options = {}) {
  const { data, loading, error, trigger, cancel } = useAsyncAction(
    action,
    defaults(options, { initiallyLoading: true })
  );

  useEffect(() => {
    const cleanupFunctions = [];
    trigger((cleanup) => cleanupFunctions.unshift(cleanup));
    return () => cleanupFunctions.forEach((f) => f());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, ...dependencies]);

  return { data, loading, error, reload: trigger, cancel };
}
